import { BoxGeometry, Mesh, MeshBasicMaterial, Object3D, Quaternion, Vector3 } from 'three';
import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import { MaterialImprovement } from '../../utils/MaterialImprovement';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from '../../utils/PreparationPickingObjects';
export default class AlcoModule extends ViewerModule {
    constructor(instruments, instrumentsPositions, table, pointerController, level, sprayModule) {
        super();
        this.instruments = instruments;
        this.instrumentsPositions = instrumentsPositions;
        this.table = table;
        this.pointerController = pointerController;
        this.level = level;
        this.sprayModule = sprayModule;
        this.__inited = false;
        this.alcoActive = false;
        this.ragActive = false;
        this.ragMoveCallbacks = [];
        this.areaContainer = new Object3D();
        this.areaContainer.position.y = 0.04;
        // PREPARE ALCO SPRAY POINTS
        this.table.add(this.areaContainer);
        // INIT ALCO SPRAY
        this.alcoHolder = new Mesh(new BoxGeometry(.7, 0.1, .7), new MeshBasicMaterial({ color: 0x0000FF }));
        this.alcoHolder.position.copy(this.instruments.alco.position);
        this.alcoHolder.position.y -= 0.7;
        this.alcoHolder.visible = false;
        this.table.getObjectByName('ph_group').add(this.alcoHolder);
        this.ragHolder = new Mesh(new BoxGeometry(.8, 0.1, .8), new MeshBasicMaterial({ color: 0xFFFF00 }));
        this.ragHolder.position.copy(this.instruments.rag.position);
        this.ragHolder.position.y = 3.04;
        this.ragHolder.name = 'RAG HOLDER';
        this.ragHolder.visible = false;
        this.table.getObjectByName('ph_group').add(this.ragHolder);
        this.initFirstSpots();
    }
    initFirstSpots() {
        var _a;
        let alcoholedCounter = 0;
        let wipedCounter = 0;
        this.areas = [];
        [new Vector3(-.35, 3.1, 2.65), new Vector3(1.85, 3.1, 2.75)].forEach((el, index) => {
            const area = new Object3D();
            const spot = deepClone(ResourcesManager.getModel('petri_spots_1').clone());
            spot.userData.improveMaterialIgnore = true;
            area.add(spot);
            const drops = deepClone(ResourcesManager.getModel('petri_drops').clone());
            drops.userData.improveMaterialIgnore = true;
            area.position.copy(el);
            area.name = 'area ' + index;
            area.userData.alcoholed = false;
            area.userData.wiped = false;
            this.areas.push(area);
            this.actionController.on(ActionControllerEventName.click, area, (even) => {
                if (Viewer.controls.zController)
                    return;
                if (!this.level.interaction)
                    return;
                if (this.alcoActive) {
                    if (area.userData.alcoholed)
                        return;
                    ResourcesManager.getAudioManger().getAudio('spray_sound').play();
                    this.spray(400, 1);
                    area.userData.alcoholed = true;
                    spot.visible = false;
                    area.add(drops);
                    if (++alcoholedCounter === 2) { // 2 areas
                        // NEXT STEP
                        this.fire('alcoholed');
                        console.log('alcoholed');
                        this.actionController.off(ActionControllerEventName.click, this.instruments.alco, this.alcoActionCallback);
                    }
                }
                else {
                    // ERROR FIRST SPRAY ALCO AND THAN WIPE
                    return;
                }
            });
            const onCheckWipeDrop = () => {
                if (!this.level.interaction)
                    return;
                if (this.ragActive && !area.userData.wiped && area.userData.alcoholed) {
                    drops.children[0].material.opacity -= .21;
                    drops.children[0].material.needsUpdate = true;
                    if (drops.children[0].material.opacity <= 0) {
                        area.userData.wiped = true;
                        area.visible = false;
                        if (++wipedCounter === 2) { // 2 areas
                            // NEXT STEP
                            this.fire('wiped');
                            this.fire('wipe2');
                            console.log('wiped');
                            console.log('wiped2');
                            this.actionController.off(ActionControllerEventName.click, this.instruments.rag, this.ragActionCallback);
                            if (this.level.lobby.app.zSpacePickingController) {
                                this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.MOVED, this.instruments.rag);
                            }
                        }
                    }
                }
            };
            this.actionController.on(ActionControllerEventName.over, area, () => {
                if (Viewer.controls.zController)
                    return;
                onCheckWipeDrop();
            });
            this.actionController.on(ActionControllerEventName.out, area, () => {
                if (Viewer.controls.zController)
                    return;
                if (!this.level.interaction)
                    return;
            });
            let allowCheckDistance = true;
            this.actionController.on(ActionControllerEventName.click, this.table, (even) => {
                if (!Viewer.controls.zController)
                    return;
                if (!this.level.interaction)
                    return;
                if (this.alcoActive) {
                    const distanceToArea = this.instruments.alco.getWorldPosition(new Vector3()).distanceTo(area.getWorldPosition(new Vector3()));
                    if (distanceToArea < 1.7) {
                        if (area.userData.alcoholed)
                            return;
                        ResourcesManager.getAudioManger().getAudio('spray_sound').play();
                        this.spray(400, 1);
                        area.userData.alcoholed = true;
                        spot.visible = false;
                        area.add(drops);
                        if (++alcoholedCounter === 2) { // 2 areas
                            // NEXT STEP
                            this.fire('alcoholed');
                            console.log('alcoholed');
                            // this.actionController.off(ActionControllerEventName.click, this.table);
                        }
                    }
                }
            });
            if (this.level.lobby.app.zSpacePickingController) {
                this.ragMoveCallbacks.push(() => {
                    this.instruments.rag.position.y = this.instruments.rag.userData.prevWorldPosition.y;
                    if (drops.getWorldPosition(new Vector3()).distanceTo(this.instruments.rag.getWorldPosition(new Vector3())) > 1.2)
                        allowCheckDistance = true;
                    if (allowCheckDistance && drops.getWorldPosition(new Vector3()).distanceTo(this.instruments.rag.getWorldPosition(new Vector3())) < 0.8) {
                        allowCheckDistance = false;
                        onCheckWipeDrop();
                    }
                });
                // this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.MOVED, this.instruments.rag, () => {
                //
                //     this.instruments.rag.position.y = this.instruments.rag.userData.prevWorldPosition.y;
                //
                //     if (drops.getWorldPosition(new Vector3()).distanceTo(this.instruments.rag.getWorldPosition(new Vector3())) > 1.2) allowCheckDistance = true;
                //     if (allowCheckDistance && drops.getWorldPosition(new Vector3()).distanceTo(this.instruments.rag.getWorldPosition(new Vector3())) < 0.8) {
                //         allowCheckDistance = false;
                //
                //         onCheckWipeDrop();
                //     }
                // });
            }
            this.areaContainer.add(area);
        });
        this.actionController.on(ActionControllerEventName.click, this.instruments.alco, this.alcoActionCallback = (event) => {
            if (!this.level.interaction)
                return;
            if (this.alcoActive)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            this.alcoHolder.visible = true;
            this.alcoActive = true;
            this.instruments.alco.scale.set(0.85, 0.85, 0.85);
            this.instruments.alco.position.set(-.3, -.5, 0);
            const pointerWraper = new Object3D();
            pointerWraper.rotation.set(0, Math.PI / 3, -Math.PI / 2);
            pointerWraper.add(this.instruments.alco);
            pointerWraper.name = 'alco';
            this.visibilityShadow(this.instruments.alco, false);
            if (!Viewer.controls.zController) {
                this.pointerController.setObject(pointerWraper);
            }
            else {
                pointerWraper.position.copy(this.instruments.alco.position);
                const matrixWorld = this.instruments.alco.matrixWorld.clone();
                PreparationPickingObjects.saveObjectState(pointerWraper);
                PreparationPickingObjects.saveObjectState(this.instruments.alco);
                pointerWraper.traverse(el => {
                    el.userData._raycast = el.raycast;
                    el.raycast = () => { };
                });
                Viewer.scene.add(pointerWraper);
                pointerWraper.position.setFromMatrixPosition(matrixWorld);
                pointerWraper.scale.setFromMatrixScale(matrixWorld);
                this.instruments.alco.position.set(0, 0, 0);
                this.instruments.alco.rotation.set(-1.5, 0.1, -0.1);
                const eventRayDirection = new Vector3(-0.832, 0.051, -0.551);
                pointerWraper.updateMatrixWorld(true);
                pointerWraper.updateMatrixWorld(true);
                this.level.lobby.app.zSpacePickingController.forcePickUp(pointerWraper, event.distance, new Vector3(-38.17, -18.52, 12.03).add(eventRayDirection.clone().multiplyScalar(0.3 * 0.99)), new Quaternion().setFromUnitVectors(new Vector3(0, 0, -1), eventRayDirection), 0);
                // @ts-ignore
                this.level.lobby.app.zSpacePickingController.stylusController.line.visible = false;
            }
        });
        if (!((_a = Viewer.zSpace) === null || _a === void 0 ? void 0 : _a.enabled)) {
            this.actionController.on(ActionControllerEventName.click, this.alcoHolder, (event) => {
                if (Viewer.controls.zController)
                    return;
                if (!this.level.interaction)
                    return;
                if (!this.alcoActive || this.pointerController.currentPointerObjectName === 'alco')
                    return;
                this.visibilityShadow(this.instruments.alco, true);
                Viewer.pointerController.setObject(null);
                this.alcoActive = false;
                this.alcoHolder.visible = false;
                this.instruments.alco.rotation.set(0, 0, 0);
                this.instruments.alco.scale.set(1, 1, 1);
                this.instruments.alco.position.copy(this.instrumentsPositions.alco);
                this.table.add(this.instruments.alco);
                this.instruments.alco.traverse(el => {
                    var _a, _b;
                    if ((_a = el.userData) === null || _a === void 0 ? void 0 : _a._raycast)
                        el.raycast = (_b = el.userData) === null || _b === void 0 ? void 0 : _b._raycast;
                });
            });
        }
        else {
            this.actionController.on(ActionControllerEventName.click, this.table, (event) => {
                if (!Viewer.controls.zController)
                    return;
                if (!this.level.interaction)
                    return;
                if (!this.alcoActive)
                    return;
                const distanceToAlcoHolder = this.instruments.alco.getWorldPosition(new Vector3()).distanceTo(this.alcoHolder.getWorldPosition(new Vector3()));
                if (distanceToAlcoHolder < 1.7) {
                    this.visibilityShadow(this.instruments.alco, true);
                    Viewer.pointerController.setObject(null);
                    this.alcoActive = false;
                    this.alcoHolder.visible = false;
                    this.level.lobby.app.zSpacePickingController.forceRelease();
                    // @ts-ignore
                    this.level.lobby.app.zSpacePickingController.stylusController.line.visible = true;
                    this.instruments.alco.rotation.set(0, 0, 0);
                    this.instruments.alco.scale.set(1, 1, 1);
                    this.instruments.alco.position.copy(this.instrumentsPositions.alco);
                    this.table.add(this.instruments.alco);
                    this.instruments.alco.traverse(el => {
                        var _a, _b;
                        if ((_a = el.userData) === null || _a === void 0 ? void 0 : _a._raycast)
                            el.raycast = (_b = el.userData) === null || _b === void 0 ? void 0 : _b._raycast;
                    });
                }
            });
        }
        this.actionController.on(ActionControllerEventName.click, this.table, (event) => {
            if (!Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            if (!this.alcoActive)
                return;
            const distanceToAlcoHolder = this.instruments.alco.getWorldPosition(new Vector3()).distanceTo(this.alcoHolder.getWorldPosition(new Vector3()));
            if (distanceToAlcoHolder < 1.7) {
                this.visibilityShadow(this.instruments.alco, true);
                Viewer.pointerController.setObject(null);
                this.alcoActive = false;
                this.alcoHolder.visible = false;
                this.level.lobby.app.zSpacePickingController.forceRelease();
                // @ts-ignore
                this.level.lobby.app.zSpacePickingController.stylusController.line.visible = true;
                this.instruments.alco.rotation.set(0, 0, 0);
                this.instruments.alco.scale.set(1, 1, 1);
                this.instruments.alco.position.copy(this.instrumentsPositions.alco);
                this.table.add(this.instruments.alco);
                this.instruments.alco.traverse(el => {
                    var _a, _b;
                    if ((_a = el.userData) === null || _a === void 0 ? void 0 : _a._raycast)
                        el.raycast = (_b = el.userData) === null || _b === void 0 ? void 0 : _b._raycast;
                });
                // this.actionController.off(ActionControllerEventName.click, this.table, eventTableClick);
            }
        });
    }
    initRagWiping() {
        this.actionController.on(ActionControllerEventName.click, this.instruments.rag, this.ragActionCallback = (event) => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            if (this.ragActive)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            this.ragHolder.visible = true;
            this.ragActive = true;
            const pointerWraper = new Object3D();
            this.instruments.rag.scale.set(0.85, 0.85, 0.85);
            this.instruments.rag.position.set(0, 0, 0);
            pointerWraper.add(this.instruments.rag);
            pointerWraper.name = 'rag';
            this.visibilityShadow(this.instruments.rag, false);
            this.pointerController.setObject(pointerWraper);
        });
        this.actionController.on(ActionControllerEventName.click, this.ragHolder, (event) => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            if (!this.ragActive || this.pointerController.currentPointerObjectName === 'rag')
                return;
            this.visibilityShadow(this.instruments.rag, true);
            Viewer.pointerController.setObject(null);
            this.ragActive = false;
            this.ragHolder.visible = false;
            this.instruments.rag.scale.set(1, 1, 1);
            this.instruments.rag.position.copy(this.instrumentsPositions.rag);
            this.table.add(this.instruments.rag);
        });
        if (Viewer.controls.zController) {
            // this.instruments.rag.traverse(el => {
            //     if (el.userData?._raycast) el.raycast = el.userData?._raycast;
            // });
            let ragPosY;
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.instruments.rag, this.ragPickCallback = (event) => {
                // @ts-ignore
                this.level.lobby.app.zSpacePickingController.stylusController.line.visible = false;
                if (!this.instruments.rag.userData.prevWorldPosition) {
                    PreparationPickingObjects.saveObjectState(this.instruments.rag);
                }
                ragPosY = this.instruments.rag.userData.prevWorldPosition.y;
                Viewer.scene.add(this.instruments.rag);
                if (!this.level.interaction)
                    return;
                if (this.ragActive)
                    return;
                if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                    return;
                this.ragActive = true;
                this.visibilityShadow(this.instruments.rag, false);
            });
            // this.ragMoveCallbacks.forEach(ragMoveFunction)
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.MOVED, this.instruments.rag, this.ragPickCallback = (event) => {
                this.instruments.rag.quaternion.copy(this.instruments.rag.userData.prevQuaternion);
                this.ragMoveCallbacks.forEach(ragMoveFunction => ragMoveFunction());
            });
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.instruments.rag, (event) => {
                // @ts-ignore
                this.level.lobby.app.zSpacePickingController.stylusController.line.visible = true;
                PreparationPickingObjects.flyObjectToPrevState(this.instruments.rag);
            });
        }
    }
    newSpray() {
        this.actionController.off(ActionControllerEventName.click, this.table);
        let alcoPosition = this.instruments.alco.position.clone();
        let alcoRotation = this.instruments.alco.rotation.clone();
        let parent = this.instruments.alco.parent;
        parent.remove(this.instruments.alco);
        this.actionController.off(null, this.instruments.alco);
        parent.add(this.instruments.alco = ResourcesManager.getModel('petri_alco'));
        MaterialImprovement.upgradeMaterialsFromModel(this.instruments.alco);
        this.instruments.alco.position.copy(alcoPosition);
        this.instruments.alco.rotation.copy(alcoRotation);
        let alcoholedCounter = 0;
        let wipedCounter = 0;
        [new Vector3(-.35, 3.1, 2.65), new Vector3(1.85, 3.1, 2.75)].forEach((el, index) => {
            const area = new Object3D();
            const spot = deepClone(ResourcesManager.getModel('petri_spots_1').clone());
            area.add(spot);
            const drops = deepClone(ResourcesManager.getModel('petri_drops').clone());
            drops.visible = false;
            area.add(drops);
            area.position.copy(el);
            area.name = 'area ' + index;
            area.userData.alcoholed = false;
            area.userData.wiped = false;
            this.areas.push(area);
            this.actionController.on(ActionControllerEventName.click, area, (even) => {
                if (Viewer.controls.zController)
                    return;
                if (!this.level.interaction)
                    return;
                if (this.alcoActive) {
                    if (area.userData.alcoholed)
                        return;
                    ResourcesManager.getAudioManger().getAudio('spray_sound').play();
                    this.spray(400, 2);
                    area.userData.alcoholed = true;
                    spot.visible = false;
                    drops.visible = true;
                    if (++alcoholedCounter === 2) { // 2 areas
                        // NEXT STEP
                        this.fire('alcoholed2');
                        console.log('alcoholed2');
                        this.actionController.off(ActionControllerEventName.click, this.instruments.alco, this.alcoActionCallback);
                    }
                }
                else {
                    // ERROR FIRST SPRAY ALCO AND THAN WIPE
                    return;
                }
            });
            const onCheckWipeDrop = () => {
                if (!this.level.interaction)
                    return;
                if (this.ragActive && !area.userData.wiped && area.userData.alcoholed) {
                    drops.children[0].material.opacity -= .21;
                    drops.children[0].material.needsUpdate = true;
                    if (drops.children[0].material.opacity <= 0) {
                        area.userData.wiped = true;
                        area.visible = false;
                        if (++wipedCounter === 2) { // 2 areas
                            // NEXT STEP
                            this.fire('wiped2');
                            console.log('wiped2');
                            this.actionController.off(ActionControllerEventName.click, this.instruments.rag, this.ragActionCallback);
                            if (Viewer.controls.zController) {
                                this.level.lobby.app.zSpacePickingController.once(PickingControllerEvents.RELEASED, this.instruments.rag, () => {
                                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.instruments.rag);
                                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.MOVED, this.instruments.rag);
                                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.instruments.rag);
                                });
                            }
                            // this.areaContainer.parent.remove(this.areaContainer);
                        }
                    }
                }
            };
            this.actionController.on(ActionControllerEventName.over, area, () => {
                if (Viewer.controls.zController)
                    return;
                onCheckWipeDrop();
            });
            this.actionController.on(ActionControllerEventName.out, area, () => {
                if (Viewer.controls.zController)
                    return;
            });
            let allowCheckDistance = true;
            if (Viewer.controls.zController) {
                this.actionController.on(ActionControllerEventName.click, this.table, (even) => {
                    if (!this.level.interaction)
                        return;
                    if (this.alcoActive) {
                        const distanceToArea = this.instruments.alco.getWorldPosition(new Vector3()).distanceTo(area.getWorldPosition(new Vector3()));
                        if (distanceToArea < 1.7) {
                            if (area.userData.alcoholed)
                                return;
                            ResourcesManager.getAudioManger().getAudio('spray_sound').play();
                            this.spray(400, 2);
                            area.userData.alcoholed = true;
                            spot.visible = false;
                            drops.visible = true;
                            if (++alcoholedCounter === 2) { // 2 areas
                                // NEXT STEP
                                this.fire('alcoholed2');
                                console.log('alcoholed2');
                                // this.actionController.off(ActionControllerEventName.click, this.table);
                                this.actionController.off(ActionControllerEventName.click, this.instruments.alco, this.alcoActionCallback);
                            }
                        }
                    }
                });
                this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.MOVED, this.instruments.rag, (event) => {
                    this.instruments.rag.position.y = this.instruments.rag.userData.prevWorldPosition.y;
                    if (drops.getWorldPosition(new Vector3()).distanceTo(this.instruments.rag.position.clone()) > 1.2)
                        allowCheckDistance = true;
                    if (allowCheckDistance && drops.getWorldPosition(new Vector3()).distanceTo(this.instruments.rag.position.clone()) < 0.8) {
                        allowCheckDistance = false;
                        onCheckWipeDrop();
                    }
                });
            }
            this.areaContainer.add(area);
        });
        // this.areaContainer.visible = false;
        // INIT ALCO SPRAY
        let alcoHolder = new Mesh(new BoxGeometry(.7, 0.1, .7), new MeshBasicMaterial({ color: 0x0000FF }));
        alcoHolder.position.copy(this.instruments.alco.position);
        alcoHolder.position.y -= 0.7;
        alcoHolder.visible = false;
        this.table.getObjectByName('ph_group').add(alcoHolder);
        this.actionController.on(ActionControllerEventName.click, this.instruments.alco, this.alcoActionCallback = (event) => {
            if (!this.level.interaction)
                return;
            if (this.alcoActive)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            alcoHolder.visible = true;
            this.alcoActive = true;
            const pointerWraper = new Object3D();
            pointerWraper.rotation.set(0, Math.PI / 3, -Math.PI / 2);
            this.instruments.alco.position.set(-.3, -.5, 0);
            this.instruments.alco.scale.set(0.7, 0.7, 0.7);
            pointerWraper.add(this.instruments.alco);
            pointerWraper.name = 'alco';
            this.visibilityShadow(pointerWraper, false);
            if (!Viewer.controls.zController) {
                this.pointerController.setObject(pointerWraper);
            }
            else {
                pointerWraper.position.copy(this.instruments.alco.position);
                const matrixWorld = this.instruments.alco.matrixWorld.clone();
                PreparationPickingObjects.saveObjectState(pointerWraper);
                PreparationPickingObjects.saveObjectState(this.instruments.alco);
                pointerWraper.traverse(el => {
                    el.userData._raycast = el.raycast;
                    el.raycast = () => { };
                });
                Viewer.scene.add(pointerWraper);
                pointerWraper.position.setFromMatrixPosition(matrixWorld);
                pointerWraper.scale.setFromMatrixScale(matrixWorld);
                this.instruments.alco.position.set(0, 0, 0);
                this.instruments.alco.rotation.set(-1.5, 1.8, 0);
                console.log('EVENT RAY: ', event.ray);
                pointerWraper.updateMatrixWorld(true);
                pointerWraper.updateMatrixWorld(true);
                const eventRayDirection = new Vector3(-0.832, 0.051, -0.551);
                pointerWraper.updateMatrixWorld(true);
                this.level.lobby.app.zSpacePickingController.forcePickUp(pointerWraper, event.distance, new Vector3(-38.17, -18.52, 12.03).add(eventRayDirection.clone().multiplyScalar(0.3 * 0.99)), new Quaternion().setFromUnitVectors(new Vector3(0, 0, -1), eventRayDirection), 0);
                // @ts-ignore
                this.level.lobby.app.zSpacePickingController.stylusController.line.visible = false;
            }
        });
        this.actionController.on(ActionControllerEventName.click, alcoHolder, (event) => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            if (!this.alcoActive || this.pointerController.currentPointerObjectName === 'alco')
                return;
            this.visibilityShadow(this.instruments.alco, true);
            Viewer.pointerController.setObject(null);
            this.alcoActive = false;
            alcoHolder.visible = false;
            this.instruments.alco.rotation.set(0, 0, 0);
            this.instruments.alco.scale.set(1, 1, 1);
            this.instruments.alco.position.copy(this.instrumentsPositions.alco);
            this.table.add(this.instruments.alco);
            this.instruments.alco.traverse(el => {
                var _a, _b;
                if ((_a = el.userData) === null || _a === void 0 ? void 0 : _a._raycast)
                    el.raycast = (_b = el.userData) === null || _b === void 0 ? void 0 : _b._raycast;
            });
        });
        let eventTableClick;
        this.actionController.on(ActionControllerEventName.click, this.table, eventTableClick = (event) => {
            if (!Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            if (!this.alcoActive)
                return;
            const distanceToAlcoHolder = this.instruments.alco.getWorldPosition(new Vector3()).distanceTo(alcoHolder.getWorldPosition(new Vector3()));
            if (distanceToAlcoHolder < 1.7) {
                this.visibilityShadow(this.instruments.alco, true);
                Viewer.pointerController.setObject(null);
                this.alcoActive = false;
                alcoHolder.visible = false;
                this.level.lobby.app.zSpacePickingController.forceRelease();
                // @ts-ignore
                this.level.lobby.app.zSpacePickingController.stylusController.line.visible = true;
                this.instruments.alco.rotation.set(0, 0, 0);
                this.instruments.alco.scale.set(1, 1, 1);
                this.instruments.alco.position.copy(this.instrumentsPositions.alco);
                this.table.add(this.instruments.alco);
                this.instruments.alco.traverse(el => {
                    var _a, _b;
                    if ((_a = el.userData) === null || _a === void 0 ? void 0 : _a._raycast)
                        el.raycast = (_b = el.userData) === null || _b === void 0 ? void 0 : _b._raycast;
                });
                this.actionController.off(ActionControllerEventName.click, this.table, eventTableClick);
            }
        });
    }
    newRagWiping() {
        this.actionController.on(ActionControllerEventName.click, this.instruments.rag, this.ragActionCallback = (event) => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            if (this.ragActive)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            this.ragHolder.visible = true;
            this.ragActive = true;
            const pointerWraper = new Object3D();
            this.instruments.rag.scale.set(0.85, 0.85, 0.85);
            this.instruments.rag.position.set(0, 0, 0);
            pointerWraper.add(this.instruments.rag);
            pointerWraper.name = 'rag';
            this.visibilityShadow(pointerWraper, false);
            this.pointerController.setObject(pointerWraper);
        });
        this.actionController.on(ActionControllerEventName.click, this.ragHolder, (event) => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            if (!this.ragActive || this.pointerController.currentPointerObjectName === 'rag')
                return;
            this.visibilityShadow(this.instruments.rag, true);
            Viewer.pointerController.setObject(null);
            this.ragActive = false;
            this.ragHolder.visible = false;
            this.instruments.rag.scale.set(1, 1, 1);
            this.instruments.rag.position.copy(this.instrumentsPositions.rag);
            this.table.add(this.instruments.rag);
        });
    }
    visibilityShadow(el, visibility = true) {
        const pPlane = el.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    beforeReset() {
        this.instruments.alco.parent.remove(this.instruments.alco);
    }
    reset() {
        this.actionController.off(ActionControllerEventName.click, this.table);
        // if (this.areaContainer.parent) this.areaContainer.parent.remove(this.areaContainer);
        for (let i = this.areaContainer.children.length - 1; i >= 0; i--) {
            this.areaContainer.remove(this.areaContainer.children[i]);
        }
        this.level.lobby.app.zSpacePickingController && this.level.lobby.app.zSpacePickingController.off(null, this.instruments.rag);
        this.actionController.off(null, this.ragHolder);
        this.actionController.off(null, this.instruments.alco);
        this.actionController.off(null, this.instruments.rag);
        this.actionController.off(null, this.table);
        this.areas.forEach(area => {
            this.actionController.off(null, area);
            area.visible = false;
        });
        this.events.length = 0;
        this.initFirstSpots();
    }
    update() {
    }
    spray(milliseconds, modelNumber) {
        this.instruments.alco.add(this.sprayModule.uiObject);
        if (modelNumber === 1) {
            this.sprayModule.uiObject.position.set(0.22293226028347526, 0.5580533155405795, 0);
            this.sprayModule.uiObject.rotation.set(0, 0, -1.60);
        }
        else {
            this.sprayModule.uiObject.position.set(-0.0008566357671438637, 0.5821735817372315, 0.12460287794307759);
            this.sprayModule.uiObject.rotation.set(-2.57421047249976, -1.5164944393829072, 2.1388472444632045);
        }
        this.sprayModule.uiObject.visible = true;
        setTimeout(() => {
            this.sprayModule.uiObject.visible = false;
            this.instruments.alco.remove(this.sprayModule.uiObject);
        }, milliseconds);
    }
}
